import { HttpContext, HttpContextToken } from '@angular/common/http';
import { inject, InjectionToken, Provider } from '@angular/core';

import { Observable, take } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CurrentUserPreferencesFacade } from '@recruitee/account';
import { ThemeName } from '@recruitee/theme';

export const resolveWalkthroughUrlScope = (
  scope: string | undefined,
  url: string,
  leadingSlash = false,
) => (scope === 'walkthrough' ? `onboarding${leadingSlash ? '/' : ''}${url}` : url);

export const HAS_ONBOARDING_ENDPOINT = new HttpContextToken(() => false);

export const getOptions = (options: { hasOnboarding: boolean }) => ({
  httpContext: new HttpContext().set(HAS_ONBOARDING_ENDPOINT, options.hasOnboarding),
});
export type ThemeAssetName =
  | 'browse_job.svg'
  | 'email_templates.svg'
  | 'job_description.svg'
  | 'marketplace_essential_tools.svg'
  | 'pipeline_overview.svg'
  | 'proceed_disqualify.svg'
  | 'publish_job.svg'
  | 'schedule_interview.svg'
  | 'end.svg';
export type WalkthroughAssetResolver = (
  theme: Exclude<ThemeName, 'auto'>,
  assetName: ThemeAssetName,
) => Promise<string>;
const WALKTHROUGH_ASSET_RESOLVER = new InjectionToken<WalkthroughAssetResolver>(
  'Walkthrough asset resolver',
);
export const provideWalkthroughAssetResolver = (resolver: WalkthroughAssetResolver): Provider => ({
  provide: WALKTHROUGH_ASSET_RESOLVER,
  useValue: resolver,
});

export function walkthroughAssetsResolver(filePath: ThemeAssetName): Observable<string> {
  const userPreferences = inject(CurrentUserPreferencesFacade);
  const resolver = inject(WALKTHROUGH_ASSET_RESOLVER);
  const { effectiveThemeName$ } = userPreferences;

  return effectiveThemeName$.pipe(
    take(1),
    switchMap(theme => resolver(theme, filePath)),
  );
}
